import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, InputGroup } from 'react-bootstrap';

const InputGroupCustom = ({
  textGRAppend,
  textGRPrepend,
  selectUnitAppend,
  children,
}) => {
  if (!textGRAppend && !textGRPrepend && !selectUnitAppend) {
    return <FormGroup className="qup-input-group">{children}</FormGroup>;
  }
  return (
    <FormGroup className="qup-input-group mr-b-0">
      <InputGroup
        className={
          textGRPrepend && selectUnitAppend
            ? 'single-addon-right right-select-and-prepend'
            : textGRPrepend && !textGRAppend
            ? 'single-addon-left'
            : (!textGRPrepend && textGRAppend) || selectUnitAppend
            ? 'single-addon-right'
            : ''
        }
      >
        {textGRPrepend && (
          <InputGroup.Prepend>
            <InputGroup.Text>{textGRPrepend}</InputGroup.Text>
          </InputGroup.Prepend>
        )}
        {children}
        {textGRAppend && (
          <InputGroup.Append>
            <InputGroup.Text>{textGRAppend}</InputGroup.Text>
          </InputGroup.Append>
        )}
      </InputGroup>
    </FormGroup>
  );
};

InputGroupCustom.propTypes = {
  textGRPrepend: PropTypes.string,
  textGRAppend: PropTypes.string,
  children: PropTypes.node.isRequired,
};

InputGroupCustom.defaultProps = {
  textGRPrepend: '',
  textGRAppend: '',
};

export default InputGroupCustom;
